import NumerousLogo from "@/components/logo/NumerousLogo";
import Alert from "@/components/ui/alert";

export function OrganizationInvitationsError() {
  return (
    <div className="w-full flex flex-col gap-y-2 justify-center items-center">
      <NumerousLogo type="fullLogo" size="sm" className="absolute top-4" />
      <Alert
        variant="destructive"
        title="Unable to load pending invitations"
        description="An error occurred while loading your pending invitations. Please try again later or report the problem if the issue persists."
      />
    </div>
  );
}
